"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _dispatchIntegrationEvent = require("./dispatchIntegrationEvent");
Object.keys(_dispatchIntegrationEvent).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _dispatchIntegrationEvent[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _dispatchIntegrationEvent[key];
    }
  });
});
var _dispatchBusinessEvent = require("./dispatchBusinessEvent");
Object.keys(_dispatchBusinessEvent).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _dispatchBusinessEvent[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _dispatchBusinessEvent[key];
    }
  });
});
var _dispatchCustomEvent = require("./dispatchCustomEvent");
Object.keys(_dispatchCustomEvent).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _dispatchCustomEvent[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _dispatchCustomEvent[key];
    }
  });
});
var _createCustomEvent = require("./createCustomEvent");
Object.keys(_createCustomEvent).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _createCustomEvent[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _createCustomEvent[key];
    }
  });
});
//# sourceMappingURL=index.js.map